module.exports = __webpack_public_path__ + "img/1549625452.fadb72d6.jpg";